<template>
  <div>
    <ed-form
      :data="parent.formFilter"
      :config="config"
      :response="response"
      :itens="filterItems"
    >
      <!-- <div slot="form-footer"></div> -->
    </ed-form>
  </div>
</template>

<script>
import Rest from "common/rest";
import EdModal from "common/modal";
import EdForm from "common/form";
import FormItems from "../_form/filtrar";

export default {
  name: "esocial-gerar-lote",
  mixins: [Rest],
  components: { EdModal, EdForm },
  props: {
    parent: {
      type: Object,
      default: null,
    },
  },
  watch: {
    "parent.formFilter.id_empresa"() {
      this.config.disabled.id_fdt = this.parent.formFilter.id_empresa
        ? false
        : true;
      this.config.disabled.id_funcionario = this.parent.formFilter.id_empresa
        ? false
        : true;

      this.parent.formFilter.id_fdt = null;
      this.parent.formFilter.id_funcionario = null;

      this.getFdt();
      this.getFuncionario();
    },
    "parent.formData.layout"() {
      this.config.hidden.tp_exa = ["S-2220", "S-2240"].indexOf(this.parent.formData.layout) == -1;

      if (this.config.hidden.tp_exa) {
        this.parent.formFilter.tp_exa = [];
      }
    },
    "parent.formFilter.empresa_envio_automatico"(){
      this.config.disabled.id_empresa = this.parent.formFilter.empresa_envio_automatico
      this.parent.formFilter.id_tipo_status = []

      if(this.parent.formFilter.empresa_envio_automatico){
        this.parent.formFilter.id_empresa = null
        this.parent.formFilter.id_fdt = null
        this.parent.formFilter.id_funcionario = null
        this.parent.formFilter.id_tipo_status = [328,331,336,335,330]
      }
    }
  },

  data() {
    return {
      config: {
        tipo: [327],
        click: {
          id_empresa: this.getEmpresa,
          id_fdt: this.getFdt,
          id_funcionario: this.getFuncionario,
          mostrar: this.getMostrar,
          tp_exa: this.getTipoConsulta,
          motivo_falha_geracao: this.getMotivoFalhaGeracao,
          empresa_envio_automatico:null
        },
        loading: {
          id_empresa: false,
          id_fdt: false,
          id_funcionario: false,
          mostrar: false,
          tp_exa: false,
          motivo_falha_geracao: false,
          empresa_envio_automatico:false,
        },
        list: {
          id_empresa: [],
          id_fdt: [],
          id_funcionario: [],
          mostrar: [],
          tp_exa: [],
          motivo_falha_geracao: [],
          empresa_envio_automatico:[],
        },
        disabled: {
          id_fdt: true,
          id_funcionario: true,
          empresa_envio_automatico:false,
        },
        hidden: {
          tp_exa: ["S-2220", "S-2240"].indexOf(this.parent.formData.layout) == -1,
        },
        title:{
          model:'empresa_envio_automatico',
          empresa_envio_automatico:'Selecionar empresas com processamento automático dos lotes'
        },
        description:{
          empresa_envio_automatico:'Essa campo permite selecionar automaticamente as empresas que estão definidas para processamento automático dos lotes em Esocial > Configurações >  Processar Lote'
        }
      },
      response: {},
      filterItems: [],
    };
  },

  created() {},

  mounted() {
    this.filterItems = FormItems;

    this.getEmpresa();
    this.getMostrar();
    this.getTipoConsulta();
    this.getMotivoFalhaGeracao();
  },

  methods: {
    // Espelha o catálogo de App\Models\Tenant\Esocial\Layout\EsocialMotivoFalha (api/).
    // Atualize os dois lados juntos ao adicionar/renomear um motivo.
    getMotivoFalhaGeracao() {
      this.config.list.motivo_falha_geracao = [
        { codigo: "SEM_MATRICULA", nome: "Sem matrícula" },
        { codigo: "SEM_ADMISSAO", nome: "Sem data de admissão" },
        { codigo: "TRABALHADOR_NAO_ENCONTRADO", nome: "Trabalhador não encontrado" },
        { codigo: "CPF_INVALIDO", nome: "CPF inválido" },
        { codigo: "CONSULTA_INVALIDA", nome: "Consulta inválida" },
        { codigo: "MEDICO_NAO_VINCULADO", nome: "Médico coordenador não vinculado" },
        { codigo: "FDT_INVALIDO", nome: "Frente de trabalho / CNPJ inválido" },
        { codigo: "SETOR_GHE_NAO_INFORMADO", nome: "GHE / Setor não informado" },
        { codigo: "PGR_NAO_LIBERADO", nome: "PGR / PCMSO não liberado" },
        { codigo: "RESPONSAVEL_PGR_INVALIDO", nome: "Responsável pelo PGR inválido" },
        { codigo: "FATOR_RISCO_INCOMPLETO", nome: "Fator de risco incompleto" },
        { codigo: "EPI_NAO_CADASTRADO", nome: "EPI não cadastrado" },
        { codigo: "XML_AVULSO_INCOMPLETO", nome: "XML avulso incompleto" },
        { codigo: "RISCO_NAO_INFORMADO", nome: "Nenhum risco informado" },
        { codigo: "DADOS_ASO_INCORRETOS", nome: "Dados do ASO incorretos" },
      ];
    },

    getTipoConsulta() {
      this.config.list.tp_exa = [
        { codigo: "adm", nome: "Admissional" },
        { codigo: "apos_adm,3", nome: "Após 3 meses do Admissional" },
        { codigo: "apos_adm,6", nome: "Após 6 meses do Admissional" },
        { codigo: "apos_adm,12", nome: "Após 12 meses do Admissional" },
        { codigo: "ret_tra", nome: "Retorno ao Trabalho" },
        { codigo: "mud_fun", nome: "Mudança de Risco Ocupacional" },
        { codigo: "periodicidade,0", nome: "Periódico (Sem PCMSO)" },
        { codigo: "periodicidade,3", nome: "Periódico a cada 3 meses" },
        { codigo: "periodicidade,6", nome: "Periódico a cada 6 meses" },
        { codigo: "periodicidade,12", nome: "Periódico a cada 12 meses" },
        { codigo: "periodicidade,24", nome: "Periódico a cada 24 meses" },
        { codigo: "periodicidade,36", nome: "Periódico a cada 36 meses" },
        { codigo: "dem", nome: "Demissional" },
      ];
    },

    getMostrar() {
      this.config.list.mostrar = [
        { id: 1, nome: "Apenas arquivos SEM XML gerado" },
        { id: 2, nome: "Apenas arquivos COM XML gerado" },
        { id: 3, nome: "Apenas arquivos SEM conflitos" },
        { id: 4, nome: "Apenas arquivos COM conflitos" },
      ];
    },

    getEmpresa(search) {
      this.config.loading.id_empresa = true;
      this.config.list.id_empresa = [];

      this.get("empresa", { search: search }).then((result) => {
        result = result[0];

        this.config.loading.id_empresa = false;

        if (result.status == 200) {
          this.config.list.id_empresa = result.data.data;
        }
      });
    },

    getFdt(search) {
      if (!this.parent.formFilter.id_empresa) return;

      this.config.loading.id_fdt = true;
      this.config.list.id_fdt = [];

      this.get("pcmso/fdt/" + this.parent.formFilter.id_empresa, {
        search: search,
      }).then((result) => {
        result = result[0];

        this.config.loading.id_fdt = false;

        if (result.status == 200) {
          this.config.list.id_fdt = result.data.data;
        }
      });
    },

    getFuncionario: function (_search) {
      if (!this.parent.formFilter.id_empresa) return;

      this.config.loading.id_funcionario = true;
      this.config.list.id_funcionario = [];

      this.get("/empresa/funcionario/" + this.parent.formFilter.id_empresa, {
        search: _search,
      }).then((result) => {
        result = result[0];

        this.config.loading.id_funcionario = false;

        if (result.status == 200) {
          this.config.list.id_funcionario = result.data.data;
        }
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// filter.vue?ad56fc08